import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

const DEFAULT_STATE = {
  loading: false,
  actionLoading: false,
  pollingLoading: false,

  items: [],
  page: 1,
  limit: 10,
  total: null,
  search: null,

  statusFilter: null,
  dateFromFilter: null,
  dateToFilter: null,
  isOneTimeFilter: null,
  isUnfixedAmountFilter: null,

  statistics: null,

  currentInvoice: null,

  _requestVersion: 0,

  sort: {
    sort_by: SORT_ORDER.CREATED_AT,
    sort_direction: SORT_DIRECTION.DESC,
  },

  chronologySort: {
    sort_by: 'time',
    sort_direction: 'desc',
  },
}

export default {
  ...DEFAULT_STATE,
}
